import React from 'react';
import {
    SocialFallbackStep as SocialFallbackStepCore,
    useIdentificationContext,
} from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';

export const SocialFallbackStep = () => {
    const { goToStep, goBack, hasBack } = useStepsContext();
    const { variant } = useIdentificationContext();

    return (
        <SocialFallbackStepCore
            onEmailIdentificationStep={() => goToStep('email_identification')}
            onProfileSetupStep={() => goToStep('profile_setup')}
            onSocialFallbackStep={() => goToStep('social_fallback')}
            variant={variant === 'onboarding' ? 'onboarding' : undefined}
            goBack={hasBack ? goBack : undefined}
        />
    );
};
